import React from "react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
const FrameworkSection = () => {
  const [activeTab, setActiveTab] = useState("Aptitude Test");
  const tabs = [
    "Aptitude Test",
    "Interest and preference",
    "Psychometric Traits",
    "Social & Emotional Intelligence",
    "Adversity Quotient",
  ];
  const content = {
    "Aptitude Test": (
      <div
        className="mt-6 p-6 md:p-8 lg:p-10 rounded-2xl flex flex-col md:flex-row items-center gap-4 md:gap-6 relative" // Added 'relative' here
        style={{
          background: `
      radial-gradient(circle at top right, rgba(255, 192, 203, 0.3) 150px, transparent 400px),
      #f0f4ff
    `,
        }}
      >
        <div className="flex-1 text-left">
          <div
            className="text-2xl md:text-[26px] lg:text-[28px] font-bold text-[#2563EB]"
            style={{ fontFamily: "Montserrat" }}
          >
            Aptitude Assessment
          </div>
          <p
            className="mt-3 md:mt-4 text-sm md:text-md leading-6"
            style={{ fontFamily: "Poppins" }}
          >
            This is an Aptitude Assessment designed to measure your natural
            abilities across a range of cognitive skill areas. The model we use
            is the{" "}
            <strong style={{ fontFamily: "Poppins" }}>
              Differential Aptitude Test (DAT),
            </strong>{" "}
            a widely respected tool developed in{" "}
            <strong style={{ fontFamily: "Poppins" }}>1947</strong> by{" "}
            <strong style={{ fontFamily: "Poppins" }}>
              Bennett, Seashore, and Wesman.
            </strong>{" "}
            It helps you assess key aptitude traits like verbal reasoning,
            numerical ability, abstract thinking, spatial relations, and
            mechanical reasoning and more.
          </p>
          <p
            className="mt-3 md:mt-4 font-bold text-[#050404]"
            style={{ fontFamily: "Poppins" }}
          >
            This model will:
          </p>
         <ul className="list-disc list-inside mt-1 md:mt-2 text-[#1f2937] text-sm md:text-md leading-6">
            <li
              className="w-[80%] sm:w-full flex items-start"
              style={{ fontFamily: "Poppins" }}
            >
              {/* Bullet point */}
              <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
              {/* Text container */}
              <div>
                {/* Full sentence (md and up) */}
                <span
                  className="hidden md:inline"
                  style={{ fontFamily: "Poppins" }}
                >
                  Provide deep insights into your cognitive strengths.
                </span>
 
                {/* Split sentence (below md) */}
                <span
                  className="block md:hidden"
                  style={{ fontFamily: "Poppins" }}
                >
                  <span className="block" style={{ fontFamily: "Poppins" }}>
                    Provide deep insights into your
                  </span>
                  <span className="block" style={{ fontFamily: "Poppins" }}>
                    cognitive strengths.
                  </span>
                </span>
              </div>
            </li>
            <li
              className="w-[75%] sm:w-full flex items-start"
              style={{ fontFamily: "Poppins" }}
            >
              {/* Bullet point */}
              <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
              {/* Text container */}
              <div>
                {/* Full sentence (md and up) */}
                <span
                  className="hidden md:inline"
                  style={{ fontFamily: "Poppins" }}
                >
                  Help you align your skills with the right career path.
                </span>
 
                {/* Split sentence (below md) */}
                <span
                  className="block md:hidden"
                  style={{ fontFamily: "Poppins" }}
                >
                  <span className="block" style={{ fontFamily: "Poppins" }}>
                    Help you align your skills
                  </span>
                  <span className="block" style={{ fontFamily: "Poppins" }}>
                    with the right career path.
                  </span>
                </span>
              </div>
            </li>
 
            <li
  className="w-[68%] sm:w-full flex items-start"
  style={{ fontFamily: "Poppins" }}
>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span
      className="hidden md:inline"
      style={{ fontFamily: "Poppins" }}
    >
      Enable informed academic and professional decisions.
    </span>
 
    {/* Split sentence (below md) */}
    <span
      className="block md:hidden"
      style={{ fontFamily: "Poppins" }}
    >
      <span className="block" style={{ fontFamily: "Poppins" }}>
        Enable informed
      </span>
      <span className="block" style={{ fontFamily: "Poppins" }}>
        academic and professional decisions.
      </span>
    </span>
  </div>
</li>
          </ul>
        </div>

        {/* Desktop/Larger Screens Image */}
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/aptitudeques.png'
          alt="DAT Graphic"
          className="w-[180px] hidden mdd:block md:w-[220px] lg:w-[300px] mt-4 md:mt-0"
        />

        {/* Mobile/Small Screens Image - Fixed */}
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/aptitudeques.png'
          alt="DAT Graphic"
          className="block mdd:hidden w-[120px] absolute bottom-4 right-4"
        />
      </div>
    ),
    "Interest and preference": (
      <div
        className="mt-6 p-6 md:p-8 lg:p-10 rounded-2xl flex flex-col md:flex-row items-center gap-4 md:gap-6 relative"
        style={{
          background: `
        radial-gradient(circle at top right, rgba(255, 255, 197, 0.4) 150px, transparent 400px),
        #f0f4ff
      `,
        }}
      >
        <div className="flex-1 text-left">
          <div
            className="text-2xl md:text-[26px] lg:text-[28px] font-bold text-[#2563EB]"
            style={{ fontFamily: "Montserrat" }}
          >
            Interest and Preference
          </div>
          <p
            className="mt-3 md:mt-4 text-sm md:text-md leading-6"
            style={{ fontFamily: "Poppins" }}
          >
            This is a career interest assessment designed to help you discover
            which types of work environments and roles best match your
            personality. The model we use is the Holland Code
            <strong style={{ fontFamily: "Poppins" }}> (RIASEC)</strong> Model,
            developed by psychologist
            <strong style={{ fontFamily: "Poppins" }}> John L. Holland </strong>
            in the <strong style={{ fontFamily: "Poppins" }}>
              1950s.
            </strong>{" "}
            This model categorizes careers into six personality-driven domains:
            Realistic, Investigative, Artistic, Social, Enterprising, and
            Conventional.
          </p>
          <p
            className="mt-3 md:mt-4 font-bold text-[#050404]"
            style={{ fontFamily: "Poppins" }}
          >
            This model will:
          </p>

         <ul className="flex flex-col md:flex-row md:flex-wrap gap-x-4 md:gap-x-8 mt-1 md:mt-2 text-[#1f2937] list-disc list-inside text-sm md:text-md leading-6">
            <li className="w-[80%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Identify career fields best suited to your personality and skills.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Identify career fields best</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>suited to your personality and skills.</span>
    </span>
  </div>
</li>
 
<li className="w-[75%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Reduce uncertainty in career selection with a structured approach.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Reduce uncertainty in career</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>selection with a structured approach.</span>
    </span>
  </div>
</li>
 
<li className="w-[50%] xs:w-[60%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Help you develop industry-relevant skills for long-term success.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden" style={{ fontFamily: "Poppins" }}>
      <span className="block" style={{ fontFamily: "Poppins" }}>Help you develop</span>
      <span className="block" style={{ fontFamily: "Poppins" }} >industry-relevant skills for long-term success.</span>
    </span>
  </div>
</li>
          </ul>
        </div>
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/Intrest%20Pref.png'
          alt="RIASEC GIF"
          className="w-[180px] hidden mdd:block md:w-[220px] lg:w-[290px] mt-4 md:mt-0"
        />
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/Intrest%20Pref.png'
          alt="RIASEC GIF"
          className="block mdd:hidden w-[120px] absolute bottom-4 right-4"
        />
      </div>
    ),
    "Psychometric Traits": (
      <div
        className="mt-6 p-6 md:p-8 lg:p-10 rounded-2xl flex flex-col md:flex-row items-center gap-4 md:gap-6 relative"
        style={{
          background: `
        radial-gradient(circle at top right, rgba(99, 149, 238, 0.25) 150px, transparent 300px),
        #f0f4ff
      `,
        }}
      >
        <div className="flex-1 text-left">
          <div
            className="text-2xl md:text-[26px] lg:text-[28px] font-bold text-[#2563EB]"
            style={{ fontFamily: "Montserrat" }}
          >
          Psychometric Traits
          </div>
          <p
            className="mt-3 md:mt-4 text-[#1f2937] text-sm md:text-md leading-6"
            style={{ fontFamily: "Poppins" }}
          >
            This is a personality assessment designed to give you a deeper
            understanding of your behavioral tendencies and how they influence
            your personal and professional life. The model we use is the
            <strong style={{ fontFamily: "Poppins" }}> OCEAN Model</strong>, also
            known as the <strong style={{ fontFamily: "Poppins" }}>
             Big Five Personality Traits, </strong>
              developed and refined by psychologists including{" "}
            <strong style={{ fontFamily: "Poppins" }}>Paul Costa and Robert McCrae</strong> in the{" "}
            <strong style={{ fontFamily: "Poppins" }}>1980s.</strong> It assesses five core traits : {" "}
            <strong style={{ fontFamily: "Poppins" }}>
              Openness ,Conscientiousness, Extraversion, Agreeableness, and
              Neuroticism.
            </strong>
          </p>
          <p
            className="mt-3 md:mt-4 font-bold text-[#050404]"
            style={{ fontFamily: "Poppins" }}
          >
            This model will:
          </p>
          <ul className="list-disc list-inside mt-1 md:mt-2 text-[#1f2937] text-sm md:text-md leading-6">
           <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Enhance self-awareness and better decision-making.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Enhance self-awareness</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>and better decision-making.</span>
    </span>
  </div>
</li>
 
<li className="w-[70%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Help identify career paths that fit your personality.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Help identify career paths</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>that fit your personality.</span>
    </span>
  </div>
</li>
 
<li className="w-[50%] xs:w-[60%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Strengthen adaptability, collaboration, and leadership potential.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Strengthen adaptability,</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>collaboration, and leadership potential.</span>
    </span>
  </div>
</li>
          </ul>
        </div>
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/Ocean%20Model.png'
          alt="OCEAN GIF"
          className="w-[180px] hidden mdd:block md:w-[220px] lg:w-[280px] mt-4 md:mt-0"
        />
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/Ocean%20Model.png'
          alt="OCEAN GIF"
          className="block mdd:hidden w-[120px] absolute bottom-4 right-4"
        />
      </div>
    ),
    "Social & Emotional Intelligence": (
      <div
        className="mt-6 p-6 md:p-8 lg:p-10 rounded-2xl flex flex-col md:flex-row items-center gap-4 md:gap-6 relative"
        style={{
          background: `
        radial-gradient(circle at top right, rgba(70, 160, 220, 0.4) 150px, transparent 400px),
        #f0f4ff
      `,
        }}
      >
        <div className="flex-1 text-left">
          <div
            className="text-2xl md:text-[26px] lg:text-[28px] font-bold text-[#2563EB]"
            style={{ fontFamily: "Montserrat" }}
          >
            Social & Emotional Intelligence
          </div>
          <p
            className="mt-3 md:mt-4 text-[#1f2937] text-sm md:text-md leading-6"
            style={{ fontFamily: "Poppins" }}
          >
            This is an emotional intelligence assessment designed to evaluate
            how effectively you recognize, understand, and manage emotions—both
            your own and those of others. The model we use is the
            <strong style={{ fontFamily: "Poppins" }}> Bar-On Model, </strong>
            developed by
            <strong style={{ fontFamily: "Poppins" }}> Dr. Reuven Bar-On </strong>
            in the
            <strong style={{ fontFamily: "Poppins" }}> 1990s. </strong>
            It focuses on four key areas:{" "}
            <strong style={{ fontFamily: "Poppins" }}>
              Self-Awareness, Self-Management, Social Awareness, and Social
              Skills.
            </strong>
          </p>
          <p
            className="mt-3 md:mt-4 font-bold text-[#050404]"
            style={{ fontFamily: "Poppins" }}
          >
            This model will:
          </p>
          <ul className="list-disc list-inside mt-1 md:mt-2 text-[#1f2937] text-sm md:text-md leading-6">
            <li className="flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Large bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Enhance emotional resilience and adaptability.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Enhance emotional</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>resilience and adaptability.</span>
    </span>
  </div>
</li>
 
<li className="w-[80%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Large bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Strengthen leadership, teamwork, and communication.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Strengthen leadership,</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>teamwork, and communication.</span>
    </span>
  </div>
</li>
 
<li className="w-[65%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Large bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Improve decision-making and interpersonal effectiveness.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Improve decision-making</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>and interpersonal effectiveness.</span>
    </span>
  </div>
</li>
          </ul>
        </div>
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/Bar-On%20Model.png'
          alt="BAR-ON GIF"
          className="w-[180px] hidden mdd:block md:w-[220px] lg:w-[300px] mt-4 md:mt-0"
        />
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/Bar-On%20Model.png'
          alt="BAR-ON GIF"
          className="block mdd:hidden w-[100px] absolute bottom-4 right-4"
        />
      </div>
    ),
    "Adversity Quotient": (
      <div
        className="mt-6 p-6 md:p-8 lg:p-10 rounded-2xl flex flex-col md:flex-row items-center gap-4 md:gap-6 relative"
        style={{
          background: `
        radial-gradient(circle at top right, rgba(127, 0, 255, 0.2), transparent 400px),
        #f0f4ff
      `,
        }}
      >
        <div className="flex-1 text-left">
          <div
            className="text-2xl md:text-[26px] lg:text-[28px] font-bold text-[#2563EB]"
            style={{ fontFamily: "Montserrat" }}
          >
            Adversity Quotient
          </div>
          <p
            className="mt-3 md:mt-4 text-[#1f2937] text-sm md:text-md leading-6"
            style={{ fontFamily: "Poppins" }}
          >
            This is designed to measure how effectively you deal with adversity,
            challenges, and setbacks. The model we use is the
            <strong style={{ fontFamily: "Poppins" }}> Adversity Quotient (AQ), </strong>developed by
            <strong style={{ fontFamily: "Poppins" }}> Dr. Paul G. Stoltz </strong>
            in the <strong style={{ fontFamily: "Poppins" }}>1990s.</strong> It is built around the
            <strong style={{ fontFamily: "Poppins" }}> CORE Model,</strong>{" "}
            which evaluates four key dimensions of resilience:{" "}
            <strong style={{ fontFamily: "Poppins" }}>Control, Ownership, Reach, and Endurance.</strong>
          </p>
          <p
            className="mt-3 md:mt-4 font-bold text-[#050404]"
            style={{ fontFamily: "Poppins" }}
          >
            This model will:
          </p>
         <ul className="flex flex-col md:flex-row md:flex-wrap gap-x-4 md:gap-x-8 mt-1 md:mt-2 text-[#1f2937] list-disc list-inside text-sm md:text-md leading-6">
            <li className="w-[80%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Identify career fields best suited to your personality and skills.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Identify career fields best</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>suited to your personality and skills.</span>
    </span>
  </div>
</li>
 
<li className="w-[75%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Reduce uncertainty in career selection with a structured approach.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden">
      <span className="block" style={{ fontFamily: "Poppins" }}>Reduce uncertainty in career</span>
      <span className="block" style={{ fontFamily: "Poppins" }}>selection with a structured approach.</span>
    </span>
  </div>
</li>
 
<li className="w-[50%] xs:w-[60%] md:w-full flex items-start" style={{ fontFamily: "Poppins" }}>
  {/* Bullet point */}
  <span className="text-2xl mr-2 mt-[-4px]">•</span>
 
  {/* Text container */}
  <div>
    {/* Full sentence (md and up) */}
    <span className="hidden md:inline" style={{ fontFamily: "Poppins" }}>
      Help you develop industry-relevant skills for long-term success.
    </span>
   
    {/* Split sentence (below md) */}
    <span className="block md:hidden" style={{ fontFamily: "Poppins" }}>
      <span className="block" style={{ fontFamily: "Poppins" }}>Help you develop</span>
      <span className="block" style={{ fontFamily: "Poppins" }} >industry-relevant skills for long-term success.</span>
    </span>
  </div>
</li>
          </ul>
        </div>
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/Core%20Model.png'
          alt="CORE GIF"
          className="w-[180px] hidden mdd:block md:w-[220px] lg:w-[300px] mt-4 md:mt-0"
        />
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/Core%20Model.png'
          alt="CORE GIF"
          className="block mdd:hidden w-[70px] sm:[110px] absolute bottom-4 right-4"
        />
      </div>
    ),
  };
  return (
    <>
      <div className="hidden mdd:block">
        <section className="relative bg-gradient-to-r h-[350px] md:h-[400px] lg:h-[450px] flex-col justify-center items-center from-pink-200 via-purple-200 to-blue-200 text-center py-12 md:py-16 px-4 mx-4 md:mx-7 my-6 md:my-9 overflow-hidden">
          {/* Top Left GIF - Speed Meter */}
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/Meter%20GIF.gif'
            alt="Speed Meter"
            className="absolute top-2 md:top-4 left-2 md:left-4 w-16 md:w-20 lg:w-23 h-[100px] md:h-[120px] lg:h-[150px]"
          />

          {/* Top Right GIF - Trophy */}
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/Trophy+GIF.gif'
            alt="Trophy"
            className="absolute top-2 md:top-4 right-2 md:right-4 w-16 md:w-20 lg:w-23 h-[100px] md:h-[120px] lg:h-[150px]"
          />

          {/* Bottom Left GIF - Brain */}
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/Brain%20GIF.gif'
            alt="Brain"
            className="absolute bottom-2 md:bottom-4 left-2 md:left-4 w-16 md:w-20 lg:w-26 h-[100px] md:h-[120px] lg:h-[150px]"
          />

          {/* Bottom Right GIF - Globe Network */}
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/earth+GIF.gif'
            alt="Globe Network"
            className="absolute bottom-2 md:bottom-4 right-2 md:right-4 w-16 md:w-24 lg:w-30 h-[100px] md:h-[120px] lg:h-[150px]"
          />

          {/* Main Content - Centered */}
          <div className="absolute inset-0 flex flex-col justify-center items-center px-2">
            <div
              className="text-2xl md:text-4xl lg:text-5xl font-bold text-black"
              style={{ fontFamily: "Montserrat" }}
            >
              Understanding the Framework:
            </div>
            <p
              className="text-lg md:text-xl lg:text-2xl mt-3 md:mt-4 text-black"
              style={{ fontFamily: "Montserrat" }}
            >
              The Science Behind the Assessment
            </p>
          </div>
        </section>
        <div className="px-2 md:px-4 pb-4 md:pb-6 max-w-7xl flex flex-col justify-center items-center mx-auto">
          {/* Tab Navigation */}
          <div className="relative w-full">
            <div className="flex overflow-x-auto pb-2 hide-scrollbar">
              <div className="flex flex-nowrap gap-2 md:gap-3 lg:gap-4 w-full">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`px-3 md:px-4 py-2 md:py-4 rounded-lg md:rounded-xl font-semibold transition duration-200 relative ${
                      activeTab === tab
                        ? "text-white bg-blue-600"
                        : "text-gray-700 bg-gray-100 hover:bg-gray-200"
                    }`}
                    style={{
                      fontFamily: "Poppins",
                      minWidth: "140px",
                      md: { minWidth: "160px" },
                      lg: { minWidth: "180px" },
                      flex: "1 0 0",
                      fontSize: "1rem",
                      md: { fontSize: "0.9rem" },
                      lg: { fontSize: "1rem" },
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
            {/* Blue Indicator Bar Container */}
            <div className="w-full h-2 bg-gray-200 mt-2 relative">
              <div
                className="absolute top-0 h-full transition-all duration-300"
                style={{
                  width: `calc(100% / ${tabs.length})`,
                  left: `calc(${(100 / tabs.length) * tabs.indexOf(activeTab)}%)`,
                  background:
                    "linear-gradient(to right, #3b82f6, #9333ea, #ef4444)",
                }}
              />
            </div>
          </div>
          {/* Tab Content */}
          <AnimatePresence mode="wait">
  <motion.div
    key={activeTab} // 👈 important to animate on tab change
    initial={{ opacity: 0, x: 50 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: -50 }}
    transition={{ duration: 0.5 }}
    className="mt-4 md:mt-6 w-full md:w-[85%] lg:w-[70%]"
  >
    {content[activeTab]}
  </motion.div>
</AnimatePresence>
        </div>


      </div>
      <div className="bg-white p-4 mdd:hidden">
        {/* Top section with gradient and gifs */}
        <div className="rounded-xl bg-gradient-to-r from-pink-200 via-purple-200 to-blue-200 text-center p-4 mb-6">
          <h2
            className="text-2xl font-bold mb-1 text-black"
            style={{ fontFamily: "Montserrat" }}
          >
            Understanding the Framework:
          </h2>
          <p
            className="text-base font-semibold text-black mb-3"
            style={{ fontFamily: "Montserrat" }}
          >
            The Science Behind the Assessment
          </p>
          <div className="flex justify-center gap-2">
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/Brain%20GIF.gif'
              alt="Brain"
              className="w-12 h-12 sm:w-20 sm:h-20"
            />
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/Meter%20GIF.gif'
              alt="Meter"
              className="w-12 h-12 sm:w-20 sm:h-20"
            />
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/Trophy+GIF.gif'
              alt="Trophy"
              className="w-12 h-12 sm:w-20 sm:h-20"
            />
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/earth+GIF.gif'
              alt="Globe"
              className="w-12 h-12 sm:w-20 sm:h-20"
            />
          </div>
        </div>
        {/* Tab buttons */}
        <div className="space-y-3">
          {tabs.map((tab) => (
            <div
              key={tab}
              style={{ fontFamily: "Poppins" }}
              className={`cursor-pointer px-4 py-3 rounded-xl text-center text-base font-medium transition-all duration-200 ${
                activeTab === tab
                  ? "bg-gradient-to-r from-blue-500 to-red-500 text-white shadow-md"
                  : "bg-violet-100 text-black"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>
        {/* Active tab content */}
        <AnimatePresence mode="wait">
        <motion.div   key={activeTab} // 👈 important to animate on tab change
    initial={{ opacity: 0, x: 50 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: -50 }}
    transition={{ duration: 0.5 }} className="mt-6 rounded-xl text-sm text-gray-800 shadow-sm">
          {content[activeTab]}
        </motion.div></AnimatePresence>
      </div>
    </>
  );
};

export default FrameworkSection;
